import { forwardRef, memo } from 'react';

import { StyledInput } from './TypographyInput.styles';
import { TypographyInputProps } from './TypographyInput.types';

export const TypographyInput = memo(
  forwardRef<HTMLInputElement, TypographyInputProps>((props, ref) => (
    <StyledInput {...props} key="typography-input" ref={ref} />
  )),
);
